function getVisibleElementsInDisplayScreen() {
    let displayScreen = document.getElementById('displayScreen');
    let children = Array.from(displayScreen.children).filter((child)=>child.checkVisibility())

    return children;
}

function getTrialEdges() {
    let visibleElements = getVisibleElementsInDisplayScreen();
    let left = 10e9, right = -10e9;
    for(let i = 0; i < visibleElements.length; i++) {
        let currentBounds = visibleElements[i].getBoundingClientRect();
        if (currentBounds.width * currentBounds.height > 0) {
            left = currentBounds.left < left ? currentBounds.left : left;
            right = currentBounds.right > right ? currentBounds.right : right;
        }
    }
    return [left, right]
}

function adjustButtonForContent() {
    let button = document.getElementById('button1');
    let contentEdges = document.getElementById('content').getBoundingClientRect();

    button.style.top = contentEdges.bottom + 50 + "px"
}

function adjustDisplayScreen() {
    let displayScreen = document.getElementById('displayScreen');
    displayScreen.classList.add('mobile-display-screen');
}


function moveContent() {
    let content = document.getElementById('content');
    let contentEdges = content.getBoundingClientRect();

    if (columnForTrial('type', trialRow) != "instructions") {
        return;
    }

    if (contentEdges.bottom < window.screen.height) {
        return;
    }


    let title = columnForTrial('title', trialRow);
    let head = columnForTrial('head', trialRow);

    if(title == "na" && head == "na") {
        content.classList.add('mobile-content');
    } else {
        content.classList.add('mobile-content-with-title');
    }

    adjustDisplayScreen();
    adjustButtonForContent();
}

function adjustFormForMobile() {
    if (columnForTrial('type', trialRow) != "form") {
        return;
    }

    let form = document.getElementById('disQuestionForm2');
    form.classList.add('mobile-question-form');
}

function adjustForMobile() {
    let edges = getTrialEdges();
    let displayScreen = document.getElementById('displayScreen');
    if(edges[0] < 0) {
        displayScreen.style.left = Math.abs(edges[0]) + 'px';
        window.scroll(Math.abs(edges[0]), 0);
    }

    moveContent();
    adjustFormForMobile();
}

function cleanMobileTricks() {
    window.scroll(0,0);
    let displayScreen = document.getElementById('displayScreen');
    let content = document.getElementById('content');
    displayScreen.style.left = 0;

    displayScreen.classList.remove('mobile-display-screen');
    content.classList.remove('mobile-content');
    content.classList.remove('mobile-content-with-title');

    let form = document.getElementById('divQuestionForm2');
    form.classList.remove('mobile-question-form');

}

function adjustStartScreen() {
    if(visualViewport.width <= 400) {
        adjustDisplayScreen();
    }
}